import { isNil, isBoolean, isNumber, isString, getAttrValue, getJoinedLocalizedAttrValues } from '@grandvisionhq/utils';

const getAttributeFactory = ({ isLocalised =false  })=>{
    if (!isLocalised) {
        return getAttrValue;
    }
    return getJoinedLocalizedAttrValues;
};
/**
 *
 * Helper for converting specification data to a string format
 *
 * if a value is an array, that value has to be converted to a string of those values. ('blue'. 'red')
 * if a value is a boolean, that value has to be converted to ('yes'/'no')
 * if a value is a number, that value has to be converted to a string of that number. (preventing things like 8.5e10)
 *
 */ const getConfigurationSpecificationItem = (configurationItem, variant, getLabel, locale)=>{
    const getAttribute = getAttributeFactory(configurationItem);
    const attr = getAttribute(variant, configurationItem.attribute, locale);
    if (isNil(attr) || attr === '') {
        return;
    }
    let value = attr;
    if (isBoolean(attr)) {
        value = attr ? getLabel('common.yes') : getLabel('common.no');
    }
    if (isNumber(attr)) {
        value = attr.toString();
    }
    // Final check for when something unexpected happend
    if (!isString(value)) {
        console.warn(`Could not render ${configurationItem.labelKey} because the received value is a ${typeof attr} while expecting a string`);
        return;
    }
    return {
        key: configurationItem.labelKey,
        label: getLabel(configurationItem.labelKey),
        value
    };
};

export { getConfigurationSpecificationItem };
//# sourceMappingURL=get-configuration-specification-item.js.map
